import { Box } from '@mui/material';
import React from 'react';
import { ASSIST_SECTION_SX } from './AssistCardHeader';
import { IAssistBodyProps } from './assistBody.types';
import HearAndConfirmBody from './HearAndConfirmBody';

export type { IAssistBodyProps };

/**
 * The per-type body slot of the assist card. Each type ticket registers its
 * body here (hear_and_confirm: HITL-1783); a type with none yet gets
 * `GenericAssistBody`. Which types are OFFERED is a separate list
 * (`RENDERABLE_ASSIST_TYPES`): a type is added there once its body is ready.
 */
export const assistRequestBodies: Partial<
  Record<string, React.ComponentType<IAssistBodyProps>>
> = {
  hear_and_confirm: HearAndConfirmBody,
};

/** The cart as the AI holds it. Read-only: an answer never touches the cart. */
export const GenericAssistBody = ({ card }: IAssistBodyProps) => {
  const cart = card.request.context?.cart ?? [];
  return (
    <Box
      data-testid="assist-generic-body"
      sx={{ ...ASSIST_SECTION_SX, fontSize: 14 }}
    >
      <Box sx={{ opacity: 0.7, fontSize: 12, mb: 0.5 }}>Cart</Box>
      {cart.length ? (
        cart.map((line, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <Box key={index}>{line.display}</Box>
        ))
      ) : (
        <Box sx={{ opacity: 0.7 }}>Empty</Box>
      )}
    </Box>
  );
};

export const getAssistBody = (type: string) =>
  assistRequestBodies[type] ?? GenericAssistBody;
